import restClient from 'Shared/hooks/restClient'

import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import './Menu.scoped.scss'
import ManageActions from '../../../Shared/components/ManageMenu/ManageActions'
import React from 'react'

export default function Menu({ campaignId, permission }) {
  const [campaign, setCampaign] = useState({})

  useEffect(() => {
    restClient.get(`/api/campaigns/${campaignId}`).then(({ data }) => setCampaign(data))
  }, [])
  return <ManageActions target={campaign} type="campaign" permission={permission} />
}

Menu.propTypes = {
  campaignId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  permission: PropTypes.string,
}
